import React from 'react';
import ReactDOM from 'react-dom';

/* redux */
import { Provider } from 'react-redux';
import configureStore from './store';

/* css */
import './assets/scss/main.scss';

/* App */
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <Provider store={configureStore()}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
